import { render, staticRenderFns } from "./OAuthCallbackLogin.vue?vue&type=template&id=15c14975&scoped=true"
import script from "./OAuthCallbackLogin.vue?vue&type=script&lang=js"
export * from "./OAuthCallbackLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c14975",
  null
  
)

export default component.exports